"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const mediaQuery_1 = require("../../cssMixins/mediaQuery");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const CopiedBox_1 = __importDefault(require("../CopiedBox"));
function CopyLinkButton(props) {
    const { onClick, tooltipPlace, disabled = false } = props;
    const [isCopied, setIsCopied] = (0, react_1.useState)(false);
    const [iconName, setIconName] = (0, react_1.useState)(ui_1.Icons.Copy_Link);
    const isLower = (0, ui_1.useScreenBreakpoint)(mediaQuery_1.size.tablet);
    const { t } = (0, i18n_1.useTranslation)();
    const updateIcon = (0, react_1.useCallback)(() => {
        setIconName(isLower ? ui_1.Icons.Share : ui_1.Icons.Copy_Link);
    }, [isLower]);
    (0, react_1.useEffect)(() => {
        updateIcon();
    }, [updateIcon, isLower]);
    const onHandleClick = () => {
        if (isCopied)
            return;
        onClick();
        if (iconName === ui_1.Icons.Copy_Link) {
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 3000);
        }
    };
    const onHandleClose = () => setIsCopied(false);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(StyledToolBarBaseButton, { tooltip: {
                    context: isCopied ? '' : t(i18n_1.Strings.toolbar.copyLinkTooltip),
                    place: tooltipPlace,
                }, onClick: onHandleClick, disabled: disabled, "$flashOnClick": true, "$isCopied": isCopied, children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: iconName, width: 24, height: 24 }) }), (0, jsx_runtime_1.jsx)(StyledCopiedBox, { onClose: onHandleClose, isOpen: isCopied })] }));
}
const StyledToolBarBaseButton = (0, ui_1.withTooltip)((0, styled_components_1.default)(ui_1.ToolBarBaseButton) `
  &:hover {
    ${({ $isCopied, isSelected, theme }) => $isCopied &&
    !isSelected &&
    (0, styled_components_1.css) `
        background: transparent;
        color: ${theme.grasshopper.menuButtons.idle};
      `}
  }
`);
const StyledCopiedBox = (0, styled_components_1.default)(CopiedBox_1.default) `
  position: absolute;
  top: 0;
  margin-top: 60px;
  margin-left: 28px;

  z-index: 999;
`;
exports.default = CopyLinkButton;
